import { render, staticRenderFns } from "./SettingScore.vue?vue&type=template&id=47704eba&scoped=true&"
import script from "./SettingScore.vue?vue&type=script&lang=js&"
export * from "./SettingScore.vue?vue&type=script&lang=js&"
import style0 from "./SettingScore.vue?vue&type=style&index=0&id=47704eba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47704eba",
  null
  
)

export default component.exports